import { render, staticRenderFns } from "./NavigationLinks.vue?vue&type=template&id=e076a54c"
import script from "./NavigationLinks.vue?vue&type=script&lang=js"
export * from "./NavigationLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports